import { render, staticRenderFns } from "./wx-open-launch-app-local.vue?vue&type=template&id=276e16f2&scoped=true&"
import script from "./wx-open-launch-app-local.vue?vue&type=script&lang=js&"
export * from "./wx-open-launch-app-local.vue?vue&type=script&lang=js&"
import style0 from "./wx-open-launch-app-local.vue?vue&type=style&index=0&id=276e16f2&lang=stylus&scoped=true&"
import style1 from "./wx-open-launch-app-local.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e16f2",
  null
  
)

export default component.exports